import React from "react";
import dynamic from "next/dynamic";
import getColor from "@gcloud-npm/utils.enums.colors";
import Text from "@/bit/components/components.text";
import CustomLink from "@/bit/components/components.custom-link";
import PropTypes from "prop-types";

const Icon = dynamic(() => import("@/bit/components/components.icon-glyph"));

const checkPropNull = (prop) => {
  return prop === null || prop === 0 || prop === "0" || prop === "";
};
/**
 * Componente que consiste en un icono, un texto y un botón (ejemplo de uso_ módulo de activación)
 */
const Alert = (props) => {
  if (!props) {
    return null;
  }

  const { cmsHandler } = props;
  const color = props.color;
  const backgroundColor = getColor(color);
  const alertText = props["cms-atom-text-1"];
  const alertLinkText = props["cms-atom-text-2"];
  const alertIcon = props["cms-atom-icon-1"];
  const alertLink = props["cms-atom-link-1"];

  let showIcon = true;
  if (
    !cmsHandler &&
    (alertIcon?.id === "" || checkPropNull(alertIcon?.width))
  ) {
    showIcon = false;
  }

  return (
    <div
      className={`cms-alert${
        color.toLowerCase() === "white" ? " no-padding" : ""
      }`}
      style={{ backgroundColor: backgroundColor }}
    >
      {cmsHandler && (
        <span
          className={
            "element-editable block edit-component cms-alert-placeholder"
          }
          onClick={() =>
            cmsHandler({
              ...props,
              name: "cms-block.cms-alert",
            })
          }
        >
          <Icon id="lapiz-m" height={20} color="white" />
        </span>
      )}
      {showIcon && (
        <div className="icon">
          <div className="icon-user">
            <Icon {...alertIcon} cmsHandler={cmsHandler} />
          </div>
        </div>
      )}

      <div className="alert-text">
        <Text
          className="modal-legals-device"
          {...alertText}
          cmsHandler={cmsHandler}
        />
        <CustomLink {...alertLink} cmsHandler={cmsHandler}>
          <Text {...alertLinkText} cmsHandler={cmsHandler} />
        </CustomLink>
      </div>

      <style jsx>{`.cms-alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 10px;
  position: relative;

  &.no-padding {
    padding: 10px 0;
  }
  &.justify-content-center {
    justify-content: center;
  }
  .alert-text {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4px;
  }

  .icon-user {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    background-color: white;
    border-radius: 50%;
    margin-right: 0.625rem;
  }
  @media screen and (max-width: 1024px) {
    padding: 8px 16px;
  }
}`}</style>
    </div>
  );
};

Alert.propTypes = {
  /**
   * {
   *  "info": "Color de fondo",
   *  "kind": "both",
   *  "beautifulName": "Color de fondo"
   * }
   */
  color: PropTypes.string,
};

Alert.defaultProps = {
  color: "",
};

export default Alert;
